export default {
  title: 'Admin Form',
  detail: 'Create or update user information',
  mobile : 'mobile',
  status: 'status',
  statusActive: 'active',
  statusInActive: 'inactive',
  lastName : 'last Name',
  firstName : 'first Name',
  back : 'back',
  success : 'success',
  error : 'error',
  save : 'save',
  loading : 'loading',
  saving : 'saving ...',
  placeholderMobile:'Enter mobile number',
  placeholderFirstName:'Enter first name',
  placeholderLastName:'Enter last name',

}
